//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.GEpkGrid.ts	                        </Name>
//    <Description> Seznam elektronické podpisové knihy							</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019							</Copyright>
//    <Created>     2019-03-21													</Created>
//  </FileHeader>

//todo: připomínka - využití metody filtrpanelu getCurrentData místo model collect

namespace Gordic.Epk.WebControls {

    const { gcontent } = Decorators;

    /** nastavení datum. políček */
    interface IEpkSettingsDate {
        caption: string | null,
        epkTermin: number | null,
        name: string | null,

        /** doporučený interval */
        recommended?: boolean;
        /** předplnění posledních X dní */
        prefill?: boolean;
        /** nastavit do na dnes */
        totoday?: boolean;
    }

    /** nastavení políčka */
    interface IEpkOptField<T> {
        value: T,
        caption: string,
    }

	/**
	 * Seznam elektronické podpisové knihy
	 */
    @gcontent
    export class GEpkGrid extends GContentBase<GEpkDbParamsNew> {


        // PARAMETRY PRO SEZNAMY

        /** např. typ požadavku: podepsat, schválit, ... */
        typPozadavku: Gordic.Wfl.Interface.TypPozadavkuEpk | null;

        /** pohledy supervisora */
        supervisor: Gordic.Wfl.Interface.EpkSupervisorEnum;

        // JQUERY ELEMENTY

        private subtaskCert: JQuery<HTMLElement>;
        /** element (grid) vyřízení žádosti v sidebaru */
        private elVyrizZadostGrid: JQuery<HTMLElement>;
        /** element (parent) vyřízení žádosti v sidebaru */
        private elVyrizZadostParent: Element;
        /** filtr element */
        private filter: JQuery<HTMLElement>;
        private sidebar: JQuery<HTMLElement>;
        /** element panelu souhrnu */
        private panelPreviewElement: JQuery<HTMLElement>;
        private attachment: JQuery<HTMLElement>;
        /** element (parent) panelu podrobnosti v sidebaru */
        private elPodrobnostiParent: JQuery<HTMLElement>;

        //#region *** PARAMETRY ***

        private tmp_row_historie: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null;
        private vyrizZadostContent: GContent;   
        private epkAttachment: Sidebar.GEpkAttachment;
        /** jsme v debugu ? */
        private IsDebug: boolean;
        private initialValueStavZadosti: IEpkOptField<Wfl.Interface.GWflczpvEnum>;
        private initialValueZpusobVyrizeni: string;
        private initialValueEpkTermin: EpkTerminEnum;
        private initialValueSupervisor: Gordic.Wfl.Interface.EpkSupervisorEnum;
        /** iniciační hodnota pro selectbox závislé */
        private initialValueZavisle: EpkZavisleEnum | null;
        /** hodnota typu termín z dashboardu hlavní stránky */
        private epk_termin?: EpkTerminEnum;
        private datVyrizeniName = "dat_vyrizeni";
        private datVyrizPlanName = "dat_vyriz_plan";
        private datPozadName = "dat_pozad";

        private settingsDate: {
            dat_vyrizeni: IEpkSettingsDate
            dat_vyriz_plan: IEpkSettingsDate
            dat_pozad: IEpkSettingsDate
        };

        /** data filtru pro ISL */
        private filterData: any;
        /** stav žádosti - seznam vlastní žádosti */
        private stavZadosti: Wfl.Interface.GWflczpvEnum;
        /** typ podepsání (osobní certifikát, pečeť, neurčeno) - ref T10497 */
        private signType: Gordic.Wfl.Interface.GEpkSignType;
        /** typ seznamu (grid) */
        private TypSeznamu: Wfl.Interface.TypSeznamuEpk;
        /**  Zvýraznění nepřečtených řádků **/
        private zvyrazneniNeprectenych: boolean;
        /** aktivní až od určité verze db */
        private zvyrazneniNeprectenychVlastni: boolean;
        /** příznak zobrazení záznamů po termínu z notifikačního centra */
        private notificationCenterFlag: boolean;
        /** objekt badgů subtasků */
        private subtask: EpkSubtask;
        private subtaskCertBadge: any;
        /** isl view gridu */
        private view: Gordic.Isl.View<Gordic.Wfl.Interface.GPodpisovaKnihaDto>;
        /** temp data řádku - vyřízení žádosti */
        private tmp_row_vyriz: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null = null;
        /** formát gridu */
        private format: Gordic.Data.GridFormat;
        /** identifikátor funkčního místa */
        private ixs_fun: string;
        /** třída obecných metod */
        private common: GEpkCommon;
        /** třída společných akcí v epk */
        private epkAction: GContent;
        /** společné akce TS */
        private epkActionTS = new GEpkActionsService();
        private filterForm: Forms.Form;
        private DateRangeOpt: Gordic.Wfl.Interface.GEpkMaxRangeDateComboBoxDto;
        /** příznak vytvoření sidebaru */
        private sidebarFlag: boolean = false;
        /** 
         *  tempRow - pro sidebar
         *  rozděleno kvůli tomu, že se selection volá vícekrát 
         * */
        private tempSidebarRow: any;
        private sidebarMinWidth = 275;

        //#endregion

        public onContentReady() {

            //test:
            //this.EpkParams.ssl_epk_plus2 = true;

            this.init();
        }

        /** metoda pro odchod z contentu */
        public closing() {
            var def = $.Deferred();
            if (this.signing === true) {
                this.dialogs.alert("jres:32000323"); //RC 32000323 : Probíhá podepisování, nelze odejít!
                def.reject();
            }
            else {
                def.resolve();
            }
            return def.promise();
        }

        private init() {
            this.epkAction = new GContent("Gordic.Epk.WebControls.GEpkActionsService");
            this.common = new GEpkCommon();
            this.setInitValues();
            this.initValuesSubtasks();
            this.setDebouncedMethod();
            this.createSubtasksVlastniZadosti();
            this.createIslGrid();
            this.createSubtasks();
            this.createFilter();
            this.createSubtaskCert();
            this.createGrid();
            this.createMenuBar();
            this.createSidebar();
        }

        private setDebouncedMethod() {
            // debounced fce na subtasky
            this.setBadgeNumbersToSubtasks = Utils.debounced(this.setBadgeNumbersToSubtasks, 300, false);
            // debounced fce, kvůli sidebarům, aby se načítali, až se doklikám na příslušný řádek
            this.updateSidebar = Utils.debounced(this.updateSidebar, 500, false);
            //debounced fce - ruční vizuální umístění
            this.epkActionTS.updateBadgeHandVisualSign = Utils.debounced(this.epkActionTS.updateBadgeHandVisualSign, 1000, false);
        }

        private createSubtasksVlastniZadosti() {
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                var params: MenuParams[] = []
                var nevyrizeno: MenuParams = {
                    action: new GAction({
                        id: Wfl.Interface.GWflczpvEnum.Nevyrizeno,
                        name: "actVlastniZadostiNevyrizeno",
                        customClass: "nevyrizeno_vlastnizadosti_subtaks_class",
                        caption: "jres:32000698",				//RC 32000698 : Nevyřízeno
                        run: () => {
                            this.stavZadosti = Wfl.Interface.GWflczpvEnum.Nevyrizeno;
                            this.updateGrid();
                            this.updateBadges();
                        }
                    }),
                    badge: this.subtask.badge.nevyrizeno
                };

                var vyrizeno: MenuParams = {
                    action: new GAction({
                        id: Wfl.Interface.GWflczpvEnum.Povoleno,
                        name: "actVlastniZadostiVyrizeno",
                        customClass: "vyrizeno_vlastnizadosti_subtaks_class",
                        caption: "jres:32000699",				//RC 32000699 : Vyřízeno
                        run: () => {
                            this.stavZadosti = Wfl.Interface.GWflczpvEnum.Povoleno;
                            this.updateGrid();
                            this.updateBadges();
                        }
                    }),
                    badge: this.subtask.badge.vyrizeno
                };

                var vraceno: MenuParams = {
                    action: new GAction({
                        id: Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani,
                        name: "actVlastniZadostiVraceno",
                        customClass: "vraceno_vlastnizadosti_subtaks_class",
                        caption: "jres:32000700",				//RC 32000700 : Vráceno k přepracování
                        run: () => {
                            this.stavZadosti = Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani;
                            this.updateGrid();
                            this.updateBadges();
                        }
                    }),
                    badge: this.subtask.badge.vraceno
                };

                params.push(nevyrizeno);
                params.push(vyrizeno);
                params.push(vraceno);

                
                var sub = $("<div class='epk_grid_subtasks_vlastnizadosti'>").appendTo(this.element);
                sub.gsubtasks({ params: params });

                if (this.stavZadosti != null)
                    sub.gsubtasks("setActive", this.stavZadosti);

            }
        }


        /** příznak pouze jednoho spuštění při vlezení na dialog */
        private onlyOnceFast: boolean;

        /** nastavení vstupních hodnot  */
        private setInitValues() {

            this.onlyOnceFast = true;

            this.row = null;
            this.signType = Gordic.Wfl.Interface.GEpkSignType.Default;
            this.typPozadavku = null; // vše
            this.signing = false;
            this.menuSchvalit = { enabled: false };
            this.menuPosoudit = { enabled: false };
            this.menuZamitnout = { enabled: false };
            this.pridatVyrizSoubor = { enabled: false };
            // nastavení vstupních hodnot pro upřesnění vyřízení
            this.common.setInitSettlementValues(this);
        }

        //#endregion

        //#region *** SUBTASKS ***

        private createSubtaskCert() {
            if (this.EpkParams.epk_shsigtypfil === false)
                return;
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                this._createSubtasksCert();
            }
        }

        private _createSubtasksCert() {

            var params: MenuParams[] = [];

            var certParam: MenuParams = {
                action: new GAction({
                    id: 0,
                    name: "actCertSubtask",
                    customClass: "cer_subtask_class",
                    caption: "Osobní certifikát",		
                    run: () => {
                        this.signType = Gordic.Wfl.Interface.GEpkSignType.PersonalCert;
                        this.updateGrid();
                    }
                }),
                badge: this.subtaskCertBadge.personalCert
            };
            params.push(certParam);

            var pecetParam: MenuParams = {
                action: new GAction({
                    id: 0,
                    name: "actPecetSubtask",
                    customClass: "pecet_subtask_class",
                    caption: "Pečeť",
                    run: () => {
                        this.signType = Gordic.Wfl.Interface.GEpkSignType.Seal;
                        this.updateGrid();
                    }
                }),
                badge: this.subtaskCertBadge.seal
            };
            params.push(pecetParam);

            var neurcenoParam: MenuParams = {
                action: new GAction({
                    id: 0,
                    name: "actNeurcenoSubtask",
                    customClass: "neurceno_subtask_class",
                    caption: "Neurčeno",
                    run: () => {
                        this.signType = Gordic.Wfl.Interface.GEpkSignType.Indetermined;
                        this.updateGrid();
                    }
                }),
                badge: this.subtaskCertBadge.indetermined
            };
            params.push(neurcenoParam);

            this.subtaskCert = $("<div class='epk_grid_cert_subtasks'>").appendTo(this.element)
                .gsubtasks({
                    params: params
                });

            this.subtaskCert.hide();
        }

        private showSubtaskCert(state: boolean) {

            if (this.EpkParams.epk_shsigtypfil === false)
                return;
            if (this.subtaskCert == null)
                return;

            if (state === true) {
                this.subtaskCert.show();
                // vždy se prvně zobrazí personalCert, pokud by default
                if (this.signType === Gordic.Wfl.Interface.GEpkSignType.Default)
                    this.signType = Gordic.Wfl.Interface.GEpkSignType.PersonalCert;                
            }
            else {
                this.subtaskCert.hide();
                //this.signType = Gordic.Wfl.Interface.GEpkSignType.Default;  
            }
        }

        private initValuesSubtasks() {

            this.subtask = {
                badge: {
                    nevyrizeno: new GObservableObject({ value: 0 }),
                    vyrizeno: new GObservableObject({ value: 0 }),
                    vraceno: new GObservableObject({ value: 0 }),
                    schvalitVyrizeniSpisu: new GObservableObject({ value: 0 }),
                    pridelit: new GObservableObject({ value: 0 }),
                    predat: new GObservableObject({ value: 0 }),
                    rozhodnout: new GObservableObject({ value: 0 }),
                    splnit: new GObservableObject({ value: 0 }),
                    vzitnavedomi: new GObservableObject({ value: 0 }),
                    posoudit: new GObservableObject({ value: 0 }),
                    schvalit: new GObservableObject({ value: 0 }),
                    podepsatschvalit: new GObservableObject({ value: 0 }),
                    podepsat: new GObservableObject({ value: 0 }),
                    vse: new GObservableObject({ value: 0 })
                }
            }

            this.subtaskCertBadge = {
                personalCert: new GObservableObject({ value: 0 }),
                seal: new GObservableObject({ value: 0 }),
                indetermined: new GObservableObject({ value: 0 }),
            };

        }

        private createSubtasks() {
            if (this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VPosouzeni) 
                this._createSubtasks();
        }

        private _createSubtasks(): void {

            var params: any = [];

            //#region Vše
            var vse: any = {
                action: new GAction({
                    id: 0,
                    name: "actVse",
                    customClass: "vse_subtaks_class",
                    caption: "jres:26265055",				//RC 26265055 : Vše
                    run: () => {
                        this.showSubtaskCert(false);
                        this.typPozadavku = null; // Vše
                        this.view.refresh();
                    }
                }),
                badge: this.subtask.badge.vse
            };
            params.push(vse);
            //#endregion

            //#region Podepsat
            var podepsat: any = {
                action: new GAction({
                    name: "actPodepsat",
                    caption: "jres:26265056",				//RC 26265056 : Podepsat
                    customClass: "podepsat_subtaks_class",
                    run: () => {
                        this.showSubtaskCert(true);
                        this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat;
                        this.view.refresh();
                    }
                }),
                badge: this.subtask.badge.podepsat
            };
            params.push(podepsat);
            //#endregion

            //#region Podepsat a schválit
            var podepsatschvalit: any = {
                action: new GAction({
                    name: "actPodepsatSchvalit",
                    caption: "jres:32000065",				//RC 32000065 : Podepsat a schválit
                    customClass: "podepsat_schvalit_subtaks_class",
                    run: () => {
                        this.showSubtaskCert(true);
                        this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
                        this.view.refresh();
                    }
                }),
                badge: this.subtask.badge.podepsatschvalit
            };
            params.push(podepsatschvalit);

            //#endregion

            //#region Schválit

            if (this.EpkParams.ssl_epk_plus! > -1 || (this.EpkParams.ssl_epk_plus! === -1 &&
                (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno ||
                this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani))) {
                var schvalit: any = {
                    action: new GAction({
                        name: "actSchvalit",
                        caption: "jres:26265058",				//RC 26265058 : Schválit
                        customClass: "schvalit_subtaks_class",
                        run: () => {
                            this.showSubtaskCert(false);
                            this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Schvalit;
                            this.view.refresh();
                        }
                    }),
                    badge: this.subtask.badge.schvalit
                };
                params.push(schvalit);
            }

            //#endregion


            //#region Posoudit

            if (this.EpkParams.ssl_epk_plus! > 0) {

                var posoudit: any = {
                    action: new GAction({
                        name: "actPosoudit",
                        caption: "jres:26265059",				//RC 26265059 : Posoudit
                        customClass: "posoudit_subtaks_class",
                        run: () => {
                            this.showSubtaskCert(false);
                            this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Posoudit;
                            this.view.refresh();
                        },

                    }),
                    badge: this.subtask.badge.posoudit
                };

                params.push(posoudit);
            }
            //#endregion

            //#region Vzít na vědomí

            if (this.EpkParams.ssl_epk_plus === 2 || this.EpkParams.ssl_epk_plus === 3) {
                var vzitnavedomi: any = {
                    action: new GAction({
                        name: "actVzitNaVedomi",
                        caption: "jres:32000207",				//RC 32000207 : Vzít na vědomí
                        customClass: "vzitnavedomi_subtaks_class",
                        run: () => {
                            this.showSubtaskCert(false);
                            this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi;
                            this.view.refresh();
                        },

                    }),
                    badge: this.subtask.badge.vzitnavedomi
                };
                params.push(vzitnavedomi);
            }

            //#endregion

            //#region Přidělit AND Předat

            if (this.EpkParams.ssl_epk_plus2 === true) {
                var pridelit: any = {
                    action: new GAction({
                        name: "actPridelit",
                        tooltip: "jres:32000632", //RC 32000632 : Schválit přidělení
                        caption: "jres:32000621",				//RC 32000621 : Přidělit
                        customClass: "pridelit_subtaks_class",
                        run: () => {
                            this.showSubtaskCert(false);
                            this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni;
                            this.view.refresh();
                        },

                    }),

                    badge: this.subtask.badge.pridelit
                };
                params.push(pridelit);
                var predat: any = {
                    action: new GAction({
                        name: "actPredat",
                        tooltip: "jres:32000633", //RC 32000633 : Schválit předání
                        caption: "jres:32000622",				//RC 32000622 : Předat
                        customClass: "predat_subtaks_class",
                        run: () => {
                            this.showSubtaskCert(false);
                            this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Predani;
                            this.view.refresh();
                        },

                    }),

                    badge: this.subtask.badge.predat
                };
                params.push(predat);

                // SCHVALIT VYŘÍZENÍ SPISU
                var schvalitVyrizeniSpisu: any = {
                    action: new GAction({
                        name: "actSchvalitVyrizeniSpisu",
                        tooltip: "jres:32000641",       //RC 32000641 : Schválit vyřízení spisu
                        caption: "jres:32000641",		//RC 32000641 : Schválit vyřízení spisu
                        customClass: "schvalit_vyrizeni_spisu_subtaks_class",
                        run: () => {
                            this.showSubtaskCert(false);
                            this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu;
                            this.view.refresh();
                        },

                    }),
                    badge: this.subtask.badge.schvalitVyrizeniSpisu
                };
                params.push(schvalitVyrizeniSpisu);
            }

            //#endregion

            //#region Splnit AND Rozhodnout

            if (this.EpkParams.ssl_epk_plus === 3) {

                    var splnit: any = {
                        action: new GAction({
                            name: "actSplnit",
                            caption: "jres:32000429",				//RC 32000429 : Splnit
                            customClass: "splnit_subtaks_class",
                            run: () => {
                                this.showSubtaskCert(false);
                                this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Splnit;
                                this.view.refresh();
                            },

                        }),
                        badge: this.subtask.badge.splnit
                    };
                    params.push(splnit);

                    var rozhodnout: any = {
                        action: new GAction({
                            name: "actRozhodnout",
                            caption: "jres:32000450",				//RC 32000450 : Rozhodnout
                            customClass: "rozhodnout_subtaks_class",
                            run: () => {
                                this.showSubtaskCert(false);
                                this.typPozadavku = Gordic.Wfl.Interface.TypPozadavkuEpk.Rozhodnout;
                                this.view.refresh();
                            },

                        }),
                        badge: this.subtask.badge.rozhodnout
                    };
                    params.push(rozhodnout);
            }

            //#endregion

            $("<div class='epk_grid_subtasks'>").appendTo(this.element)
                .gsubtasks({
                    params: params
                });
        }

        private updateBadges() {
            this.setBadgeNumbersToSubtasks();
        }

        /** nastavení čísel badgů na subtascích */
        private setBadgeNumbersToSubtasks(): void {

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VPosouzeni)
                return;

            if (this.closed === true)
                return;

            // thazmuka (31.03.2021) - pokud je hodnota filterData nenaplněna, značí to, že nebyl zavolán loadGridu - tudíž nepřekreslujeme ani subtasky
            if (this.filterData == null)
                return;

            Gordic.Isl.ElectronicSignatureBookRequest.pocetZadosti({ filters: this.getFilterPocetZadosti() })            
                .getData().then((values) => {

                if (this.closed)
                    return;

                //#region -- type sign (cert, seal,...) --

                if (this.subtaskCert != null && this.subtaskCertBadge != null && this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                    if (this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat || this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                        var personalCert = values.personalCert == null ? 0 : values.personalCert;
                        var seal = values.seal == null ? 0 : values.seal;
                        var indetermined = values.indetermined == null ? 0 : values.indetermined;
                        this.subtaskCertBadge.personalCert.update({ value: personalCert });
                        this.subtaskCertBadge.seal.update({ value: seal });
                        this.subtaskCertBadge.indetermined.update({ value: indetermined });
                    }
                }

                //#endregion

                var vse = values.vse === undefined ? 0 : values.vse === null ? 0 : values.vse;
                var podepsat = values.podepsat === undefined ? 0 : values.podepsat === null ? 0 : values.podepsat;
                var podepsatschvalit = values.podepsatschvalit === undefined ? 0 : values.podepsatschvalit === null ? 0 : values.podepsatschvalit;
                var schvalit = values.schvalit === undefined ? 0 : values.schvalit === null ? 0 : values.schvalit;
                var posoudit = values.posoudit === undefined ? 0 : values.posoudit === null ? 0 : values.posoudit;
                var vzitnavedomi = values.vzitnavedomi === undefined ? 0 : values.vzitnavedomi === null ? 0 : values.vzitnavedomi;

                // seznam vlastní žádosti
                var nevyrizeno = values.nevyrizeno == null ? 0 : values.nevyrizeno;
                var vyrizeno = values.vyrizeno == null ? 0 : values.vyrizeno;
                var vraceno = values.vraceno == null ? 0 : values.vraceno;

                // (specialita pro Ukrajinu)
                var splnit = values.splnit != null ? values.splnit : 0;
                var rozhodnout = values.rozhodnout != null ? values.rozhodnout : 0;

                // specialita pro MD
                var pridelit = values.pridelit != null ? values.pridelit : 0;
                var predat = values.predat != null ? values.predat : 0;
                var schvalitVyrizeniSpisu = values.schvalitVyrizeniSpisu != null ? values.schvalitVyrizeniSpisu : 0;

                this.setBadge(vse, podepsat, podepsatschvalit, schvalit, posoudit, vzitnavedomi, splnit, rozhodnout, pridelit, predat, schvalitVyrizeniSpisu, nevyrizeno, vyrizeno, vraceno);

            });

        }

        /** nastavení badgů */
        private setBadge(
            vse: number,
            podepsat: number,
            podepsatschvalit: number,
            schvalit: number,
            posoudit: number,
            vzitnavedomi: number,
            splnit: number,
            rozhodnout: number,
            pridelit: number,
            predat: number,
            schvalitVyrizeniSpisu: number,
            nevyrizeno: number,
            vyrizeno: number,
            vraceno: number
        ) {

            if (this.subtask != null) {
                this.subtask.badge.schvalitVyrizeniSpisu.update({ value: schvalitVyrizeniSpisu });
                this.subtask.badge.pridelit.update({ value: pridelit });
                this.subtask.badge.predat.update({ value: predat });
                this.subtask.badge.rozhodnout.update({ value: rozhodnout });
                this.subtask.badge.splnit.update({ value: splnit });
                this.subtask.badge.vzitnavedomi.update({ value: vzitnavedomi });
                this.subtask.badge.posoudit.update({ value: posoudit });
                this.subtask.badge.schvalit.update({ value: schvalit });
                this.subtask.badge.podepsatschvalit.update({ value: podepsatschvalit });
                this.subtask.badge.podepsat.update({ value: podepsat });
                this.subtask.badge.vse.update({ value: vse });
                // seznam vlastni zadosti
                this.subtask.badge.nevyrizeno.update({ value: nevyrizeno });
                this.subtask.badge.vyrizeno.update({ value: vyrizeno });
                this.subtask.badge.vraceno.update({ value: vraceno });
            }
        }

        //#endregion

        //#region *** FILTER ***

		/**
		 * vytvořit filtrpanel
		 */
        private createFilter() {
            var filterForm = this.createFilterForm();
            this.filter = $("<div>").appendTo(this.element)
            this.filter.on("gfilterpanelapply", (event, obj) => {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                if (obj != null && obj.filter != null) {
                    var filter = obj.filter;
                    this.filterData = filter;
                    this.view.requestData();
                }
            });

            var autoLoadAfterCreatePanel = true;
            // načíst až po stisku tlačítka
            if (this.EpkParams.ssl_cti_sez === epk_ssl_cti_sez_enum.PoStiskuTlacitka)
                autoLoadAfterCreatePanel = false;

            this.filter
                .gfilterpanel({
                    favorites: "all",
                    userSettings: this.userSettings,
                    forms: [filterForm],
                    autoLoadAfterCreatePanel: autoLoadAfterCreatePanel
                });

        }

        private setInitialValueFiltersForm() {
            this.initialValueStavZadosti = this.getInitialValueStavZadosti();
            this.initialValueZpusobVyrizeni = "0";
            this.initialValueEpkTermin = EpkTerminEnum.Cokoliv;
            this.initialValueSupervisor = Gordic.Wfl.Interface.EpkSupervisorEnum.Ne;
        }

        private getInitialValueStavZadosti() {
            var object: IEpkOptField<Wfl.Interface.GWflczpvEnum> = {
                value: Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani,
                caption: "jres:32000676"    //RC 32000676 : Vráceno k přepracování
            }
            return object;
        }

		/**
		 * nastavit formulář filtru
		 */
        private createFilterForm() {

            var that = this;

            //#region ** setInitialValue **

            // výchozí nastavení
            this.settingsDate = {
                dat_pozad: {
                    name: null,
                    caption: null,
                    epkTermin: null
                },
                dat_vyrizeni: {
                    name: null,
                    caption: null,
                    epkTermin: null
                },
                dat_vyriz_plan: {
                    name: null,
                    caption: null,
                    epkTermin: null
                }
            };

            if (this.globalSettings == null) {
                // globalSettings is undefined
                // predpokladam, ze i userSettings je undefined
                // tudíž nasetuji initialValue vždy stejnou dle sebe
                this.setInitialValueFiltersForm();
            }
            else {

                // globalSettings is defined
                // můžu vypnout zapamatování

                if (this.globalSettings.get("Global.Epk.AppSettings.FiltersGridSettings") === true) {
                    this.setInitialValueFiltersForm();
                }
                else {
                    if (this.userSettings == null) {
                        // userSettings is undefined
                        this.setInitialValueFiltersForm();
                    }
                    else {

                        var userSettingsFilterPanelName = "filterpanel";

                        //#region -- vlastní žádosti - vyřízeno --

                        var stavZadostiUserSettings = this.userSettings.get(userSettingsFilterPanelName + ".stav_zadosti");
                        this.initialValueStavZadosti = stavZadostiUserSettings == null ? this.getInitialValueStavZadosti() : stavZadostiUserSettings;

                        //#endregion

                        var epk_termin = this.userSettings.get(userSettingsFilterPanelName + ".epk_termin");
                        this.initialValueEpkTermin = (epk_termin == null) ? EpkTerminEnum.Cokoliv : epk_termin;

                        //#region -- SUPERVISOR --

                        if(this.supervisor == null)
                            this.supervisor = this.userSettings.get(userSettingsFilterPanelName + ".supervisor");
                        if (this.supervisor == null)
                            this.initialValueSupervisor = Gordic.Wfl.Interface.EpkSupervisorEnum.Ne;
                        else
                            this.initialValueSupervisor = this.supervisor;

                        //#endregion

                        // způsob vyřízení
                        var zpusob_vyrizeni = this.userSettings.get(userSettingsFilterPanelName + ".zpusob_vyrizeni");

                        this.initialValueZpusobVyrizeni = (zpusob_vyrizeni == null) ?
                            "0" :
                            zpusob_vyrizeni;

                        // Inicializace políčka Závislé

                        this.initialValueZavisle = this.userSettings.get(userSettingsFilterPanelName + ".zavisle");

                        if (this.EpkParams.epk_schpznav === true)
                            this.initialValueZavisle = EpkZavisleEnum.Ano;

                        if (this.epk_termin != null && this.epk_termin !== EpkTerminEnum.Cokoliv) {
                            this.initialValueZavisle = EpkZavisleEnum.Ne;
                            this.initialValueZpusobVyrizeni = "0";
                        }

                    }
                }
            }

            var initialValueTermin: string | null = null;
            var initialValueDatVyrizeni: string | null = null;
            var initialValueDatPozad: string | null = null;

            if (this.notificationCenterFlag === true) 
                initialValueTermin = "afterdeadline";

            if (this.epk_termin != null) {

                if (this.epk_termin === EpkTerminEnum.Po) {
                    initialValueTermin = "afterdeadline";
                    this.datVyrizPlanName += "_a";
                }
                else if (this.epk_termin === EpkTerminEnum.TesnePred) {
                    initialValueTermin = "justbeforedeadline";
                    this.datVyrizPlanName += "_j";
                }
                else if (this.epk_termin === EpkTerminEnum.Pred) {
                    initialValueTermin = "beforedeadline";
                    this.datVyrizPlanName += "_b";
                }
                else if (this.epk_termin === EpkTerminEnum.CelySeznam)
                    initialValueDatPozad = initialValueDatVyrizeni = initialValueTermin = "all";

            }

            //#endregion

            this.filterForm = new Gordic.Forms.Form({
                name: "FormFilterGrid",
                tabLabel: "Filtr",
                layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000"
            });

            this.filterForm
                .addSection()

            if (this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VPosouzeni) {

                if ((this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) || (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani)) {

                    if ((this.EpkParams.epk_datfiltrzob === DatFiltrZobEnum.Ano) || (this.EpkParams.epk_datfiltrzob === DatFiltrZobEnum.AnoPouzeUVyrizenych)) {

                        this.filterForm
                            .addRow("jres:32000294") //RC 32000294 : Datum vyřízení
                            .addField("gdatecombobox", {
                                epkFlag: true,
                                defaultInitialValue: "all",
                                initialValue: initialValueDatVyrizeni,
                                name: this.datVyrizeniName,
                                contextMenu: { daysRange: 60 },
                                userSettings: this.userSettings,
                                change: (ev, obj) => {
                                    this.setBadgeNumbersToSubtasks();
                                }
                            })
                    }
                }
                else {

                    if (this.EpkParams.epk_datfiltrzob === DatFiltrZobEnum.Ano) {

                        this.filterForm
                            .addRow("jres:32000090") //RC 32000090 : Termín
                            .addField("gdatecombobox", {
                                epkDnuDoTerminu: this.EpkParams.gin_epk_updoter,
                                epkFlag: true,
                                defaultInitialValue: "all",
                                initialValue: initialValueTermin,
                                name: this.datVyrizPlanName,
                                contextMenu: { daysRange: 60 },
                                userSettings: this.userSettings,
                                change: (ev, obj) => {
                                    this.setBadgeNumbersToSubtasks();
                                }
                            })
                    }

                }

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {

                    if (this.EpkParams.epk_datfiltrzob === DatFiltrZobEnum.Ano) {
                        this.filterForm
                            .addRow("jres:26265015") //RC 26265015 : Datum požadavku
                            .addField("gdatecombobox", {
                                epkFlag: true,
                                defaultInitialValue: "all",
                                initialValue: initialValueDatPozad,
                                name: this.datPozadName,
                                contextMenu: { daysRange: 60 },
                                userSettings: this.userSettings,
                                change: (ev, obj) => {
                                    this.setBadgeNumbersToSubtasks();
                                }
                            })


                    }

                }

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {

                    const data: string[] = [];
                    data.push("0"); //RC 32001073 : Vyřízeno
                    data.push("1"); //RC 32001074 : Zamítnuto
                    const view = new Data.View(data);

                    this.filterForm
                        .addRow("jres:32001072") //RC 32001072 : Stav vyřízení
                        .addField("gselectbox", {
                            initialValue: this.initialValueZpusobVyrizeni,
                            name: "zpusob_vyrizeni",
                            dropdown: true,
                            data: view,					        // 0 - true, 1 - false
                            itemTemplate: (value) => {
                                if (value === "0") {
                                    return "jres:32001073"; //RC 32001073 : Vyřízeno
                                }
                                else {
                                    return "jres:32001074"; //RC 32001074 : Zamítnuto
                                }
                            },
                            change: (ev, obj) => {
                                this._setUserSettings("zpusob_vyrizeni", obj.value);
                                this.setBadgeNumbersToSubtasks();
                            }
                        })

                }

                if (this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {

                    if (this.EpkParams.epk_prehl_org! > 0) {

                        var dataSupervisor: Gordic.Wfl.Interface.EpkSupervisorEnum[] = [
                            Gordic.Wfl.Interface.EpkSupervisorEnum.Ne
                        ];

                        if (this.EpkParams.epk_prehl_org === 1) {
                            dataSupervisor.push(Gordic.Wfl.Interface.EpkSupervisorEnum.AnoCelyUrad);
                            dataSupervisor.push(Gordic.Wfl.Interface.EpkSupervisorEnum.AnoSpisUzel);
                            dataSupervisor.push(Gordic.Wfl.Interface.EpkSupervisorEnum.AnoPodrizeneSpisUzel);
                        }
                        else if (this.EpkParams.epk_prehl_org === 2) {
                            dataSupervisor.push(Gordic.Wfl.Interface.EpkSupervisorEnum.AnoSpisUzel);
                            dataSupervisor.push(Gordic.Wfl.Interface.EpkSupervisorEnum.AnoPodrizeneSpisUzel);
                        }

                        var supervisorView = new Data.View<Gordic.Wfl.Interface.EpkSupervisorEnum>(dataSupervisor);

                        this.filterForm
                            .addRow("jres:32000593") //RC 32000593 : Vlastnictví
                            .addField("gselectbox", {
                                name: "supervisor",
                                dropdown: true,
                                emptyValue: null,
                                initialValue: this.initialValueSupervisor,
                                data: supervisorView,
                                itemTemplate: (value) => {
                                    if (value === Gordic.Wfl.Interface.EpkSupervisorEnum.AnoCelyUrad)
                                        return "jres:32000589"; //RC 32000589 : Celý úřad
                                    else if (value === Gordic.Wfl.Interface.EpkSupervisorEnum.AnoSpisUzel)
                                        return "jres:32000590"; //RC 32000590 : Aktuální spisový uzel
                                    else if (value === Gordic.Wfl.Interface.EpkSupervisorEnum.AnoPodrizeneSpisUzel)
                                        return "jres:32000592"; //RC 32000592 : Podřízené spisové uzly
                                    else
                                        return "jres:32000591"; //RC 32000591 : Funkční místo
                                },
                                change: (ev, obj) => {
                                    this._setUserSettings("supervisor", obj.value);
                                    this.supervisor = obj.value == null ? Gordic.Wfl.Interface.EpkSupervisorEnum.Ne : obj.value;
                                    this.setBadgeNumbersToSubtasks();
                                }
                            })
                    }
                }

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {

                    var dataZavisle: EpkZavisleEnum[] = [];
                    dataZavisle.push(EpkZavisleEnum.Ne);
                    dataZavisle.push(EpkZavisleEnum.Ano);

                    var viewZavisle = new Data.View<EpkZavisleEnum>(dataZavisle);

                    this.filterForm
                        .addRow("jres:32000414") //RC 32000414 : Zobrazit závislé
                        .addField("gselectbox", {
                            assistId: "zavislak",
                            initialValue: this.initialValueZavisle,
                            name: "zavisle",
                            dropdown: true,
                            data: viewZavisle,
                            itemTemplate: (value) => {
                                if (value === EpkZavisleEnum.Ano)
                                    return "jres:32000322"; //RC 32000322 : Ano
                                else if (value === EpkZavisleEnum.Ne)
                                    return "jres:32000321"; //RC 32000321 : Ne
                                else
                                    return "";
                            },
                            change: (ev, obj) => {
                                this.initialValueZavisle = obj.value;
                                this._setUserSettings("zavisle", this.initialValueZavisle);
                                this.setBadgeNumbersToSubtasks();
                            }
                        })
                }

            }

            return this.filterForm;
        }

        /**
         * uložení hodnoty do userSettings, pokud je userSettings je definováno
         * @param name název userSettings
         * @param value hodnota
         */
        private _setUserSettings(name: string, value: any) {
            if (this.userSettings != null)
                this.userSettings!.set("filterpanel." + name, value);
        }

        //#endregion

        //#region *** GRID ***

		/**
		 * vytvořit context menu na seznamu (na pravé tlačítko)
		 */
        private createContextMenu() {

            const menuBar: MenuParams[] = [];
            var barArrayString: string[] = [];

            menuBar.push(this.addDetailButton("actDetailZadostiContext"));
            barArrayString.push("actDetailZadostiContext*");
            menuBar.push(this.addDetailDokumentButton("actDetailDokumentContext"));
            barArrayString.push("actDetailDokumentContext*");

            // thazmuka 25.11.2021 - zobrazovat tlačítka pouze pokud lze vyřídit dle DB parametru T16062
            if (this.EpkParams.ssl_epk_vyrid! > 0) {        

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                    barArrayString.push("-");
                    menuBar.push(this.addVyriditButton("actVyrizeniContext"));
                    barArrayString.push("actVyrizeniContext*");
                    menuBar.push(this.addVratitButton("actVratitContext"));
                    barArrayString.push("actVratitContext*");
                    menuBar.push(this.addKPosouzeniButton("actKPosouzeniContext"));
                    barArrayString.push("actKPosouzeniContext*");
                    if (this.zvyrazneniNeprectenych === true) {
                        menuBar.push(this.addButtonNastavitNeprecteneVyrizovatel("actNeprecteneZadostVyrizovatelContext"));
                        barArrayString.push("-");
                        barArrayString.push("actNeprecteneZadostVyrizovatelContext*");
                    }
                }

            }

            // Akce Zrušit Žádost
            // thazmuka (27.2.2023) - akce se zobrazí vždy, bude jít kliknout a případně padne na nemožnost zrušení ve SPG
            // kde je to navázáno na parametr gin_epk_ukzru
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                menuBar.push(this.addZrusitZadostButton("actZrusitZadostContext"));
                barArrayString.push("-");
                barArrayString.push("actZrusitZadostContext*");
            }

            if (this.EpkParams.ssl_epk_vyrid! > 0) {

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                    if (this.zvyrazneniNeprectenychVlastni === true) {
                        menuBar.push(this.addButtonNastavitNeprectene("actNeprecteneZadostContext"));
                        barArrayString.push("-");
                        barArrayString.push("actNeprecteneZadostContext*");
                    }
                }

                if (this.TypSeznamu != Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani &&
                    this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno &&
                    this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VPosouzeni) {
                    barArrayString.push("-");
                    var priorityName = "actChangePrioritaContext";
                    menuBar.push(this.addButtonZmenaPriority(priorityName));
                    barArrayString.push(priorityName + "*");

                }

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani) {
                    if (this.zvyrazneniNeprectenych === true) {
                        menuBar.push(this.addButtonNastavitNeprecteneVyrizovatel("actNeprecteneZadostVyrizovatelContext"));
                        barArrayString.push("-");
                        barArrayString.push("actNeprecteneZadostVyrizovatelContext*");
                    }
                }

                if (this.EpkParams.gin_pdf_pictpos !== 0 && this.EpkParams.epk_povumipod !== 0) {
                    menuBar.push(this.addActionUmisteniPodpisu("actUmistitPodpisContext"));
                }

            }

            return this.actions.createBar(barArrayString);
        }

        private addButtonZmenaPriority(name: string) {

            let flashId = "flashIdPriority";

            var action = new GAction({
                icon: "fa-exclamation-triangle",
                name: name,
                caption: "jres:32000546", //RC 32000546 : Změnit prioritu
                run: (ev, obj) => {

                    this.hideFlash(flashId);

                    if (this.grid == null) {
                        this.showFlash({
                            id: flashId,
                            content: "jres:32000721", //RC 32000721 : Seznam neexistuje.
                            state: "warning"
                        });
                        return;
                    }

                    var rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] = this.grid.ggrid("getSelection");
                    if (rows == null || rows.length === 0) {
                        this.showFlash({
                            id: flashId,
                            content: "jres:32000722", //RC 32000722 : Není vybrán žádný řádek.
                            state: "warning"
                        });
                        return;
                    }

                    //#region -- validace změny priority --

                    var isValid = true;
                    for (var i = 0; i < rows.length; i++) {
                        var row = rows[i];
                        if (row == null || row.ixp == null)
                            isValid = false;
                    }

                    if (isValid === false) {
                        this.showFlash("jres:32000843", "warning", flashId); //RC 32000843 : Změna priority není k dispozici.
                        return;
                    }

                    //#endregion

                    this.call("ZmenPriorituZadostiOPodpis", { Rows: rows })
                        .then(() => {
                            this.refreshGrid();
                        })
                }
            });

            var params: MenuParams = {
                favorite: true,
                action: this.actions.add(action)
            }
            return params;
        }

        /**
         * nastavit na nepřečteno (z pohledu vyřizovatele)
         * seznamy k vyřízení, vráceno k přepracování (wflszps)
         * priz_view_epk = 0;
         */
        private addButtonNastavitNeprecteneVyrizovatel(name: string) {
            return {
                enabled: true,
                favorite: true,
                action: this.actions.add(new GAction({
                    name: name,
                    icon: "gi-pencil",
                    caption: "jres:32000422", //RC 32000422 : Označit jako nepřečtené
                    run: () => {
                        if (this.zvyrazneniNeprectenych === true) {
                            this.setNeprecteneVyrizovatel();
                        }
                    }
                }))
            } as MenuParams;
        }

        /**
         * nastavit na nepřečteno (z pohledu vlastníka)
         */
        private addButtonNastavitNeprectene(name: string) {
            return {
                enabled: true,
                favorite: true,
                action: this.actions.add(new GAction({
                    name: name,
                    icon: "gi-pencil",
                    caption: "jres:32000422", //RC 32000422 : Označit jako nepřečtené
                    run: () => {
                        if (this.zvyrazneniNeprectenychVlastni === true) {
                            this.setNeprectene();
                        }
                    }
                }))
            } as MenuParams;
        }

        //private clearSettlementReason() {
        //    this.duvod_vyrizeni = null; // vynulujeme při změně řádku
        //    this.hideFlash("idDuvodOptional");
        //}

		/**
		 * vytvořit seznam (grid)
		 * @returns
		 */
        private createGrid() {

            if (this.view == null)
                return;

            //#region ** PROFILY GRIDU **

            // thazmuka (14.10.2021)
            var povoleniFikceVyrizeni = this.EpkOpt.povoleniFikceVyrizeni == null ? false : this.EpkOpt.povoleniFikceVyrizeni;

            var gridFormat = new GEpkGridFormat({
                povoleniFikceVyrizeni: povoleniFikceVyrizeni,
                epkAction: this.epkAction,
                typSeznamu: this.TypSeznamu,
                epk_uziv_sl_fn: this.EpkParams.epk_uziv_sl_fn!,
                gin_epk_updoter: this.EpkParams.gin_epk_updoter!,
                isFazeUsu: this.EpkOpt.isFazeUsu!,
                ssl_epk_plus2: this.EpkParams.ssl_epk_plus2!,
                textCJShortDBParam: this.EpkOpt.textCJShortDBParam!,
                znackaShortText: this.EpkOpt.znackaShortText!,
            }, (row) => {
                var readonly = false;   // povolení editace políčka 
                if (this.filterData != null && this.filterData.supervisor != null && this.filterData.supervisor !== Gordic.Wfl.Interface.EpkSupervisorEnum.Ne) 
                    readonly = true;
                if (this.filterData != null && this.filterData.zavisle != null && this.filterData.zavisle === EpkZavisleEnum.Ano) 
                    readonly = true;
                return readonly;
            }, this.globalSettings);

            this.format = new Gordic.Data.GridFormat();

            var profiles: GridProfile<any>[] = [];

            //#region * MOBILE * 

            var columnListMobile = gridFormat.gridFormatMobile(new Gordic.Data.GridFormat());

            var mobileProfile: GridProfile<any> = {
                name: "jres:32000725", //RC 32000725 : Mobilní profil
                _locked: true,
                columnList: columnListMobile
            };
            profiles.push(mobileProfile);

            //var columnListMobile2 = gridFormat.gridFormatMobile2(new Gordic.Data.GridFormat());

            //var mobileProfile2: GridProfile<any> = {
            //    name: "jres:32000725 2", //RC 32000725 : Mobilní profil
            //    _locked: true,
            //    columnList: columnListMobile2
            //};
            //profiles.push(mobileProfile2);

            //#endregion

            //#region * BASIC (DEFAULT) *

            var columnList = "";
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni || this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) 
                columnList = gridFormat.gridFormatBasic(this.format);
            else
                columnList = gridFormat.gridFormatBasicDone(this.format);   // thazmuka (26.02.2021) - pridan pohled gridu pro ostatni pripady

      

            var defaultProfile: GridProfile<Gordic.Wfl.Interface.GPodpisovaKnihaDto> = {
                name: "jres:32000417", //RC 32000417 : Výchozí profil
                _locked: true,
                columnList: columnList,
                //_primary: true,
                //_default: true,
            };

            //#endregion

            //#region * SIMPLE *

            var columnListSimple = gridFormat.gridFormatSimple(new Gordic.Data.GridFormat());

            var simpleProfile: GridProfile<any> = {
                name: "jres:32000416", //RC 32000416 : Zjednodušený profil
                _locked: true,
                columnList: columnListSimple
            };
            profiles.push(simpleProfile);

            //#endregion

            //#region * EKO *

            if (this.EpkParams.epk_ekosloupce) {

                var columnListEko = gridFormat.gridFormatEko(this.format);
                var ekoProfile: GridProfile<any> = {
                    name: "jres:32000415", //RC 32000415 : Eko profil
                    _locked: true,
                    columnList: columnListEko
                };
                profiles.push(ekoProfile);
            }

            //#endregion

            //#region sloupce na prohledávání

            /** sloupce na prohledávání */
            var searchColumns = [] as string[];

            for (var index = 0; index < this.format.columns.length; index++) {
                var columns = this.format.columns[index];

                if (columns.name !== undefined) {
                    searchColumns.push(columns.name);
                }
            }

            //#endregion

            //#endregion

            /** stav multi gridu */
            let multiState = false;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni && this.EpkParams.epk_povhrovyriz === true)
                multiState = true;
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                multiState = true;
            if (Gordic.Wfl.WebClient.GetGWflDBParams().IsUkraine === true)     
                multiState = false;     // ukrajina nemá hromadné vyřízení

            //#region -- GRID --

            var sort = this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani || this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti || this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno ? "!dat_vyrizeni" : "";
                
            this.grid = $("<div>").gautofit().appendTo(this.element);

            var profile = defaultProfile;

            //if (this.globalSettings != null) {
            //    const mobileGridProfile = this.globalSettings.get("Global.Epk.AppSettings.MobileGridProfile");
            //    if (mobileGridProfile === true) {
            //        profile = mobileProfile;
            //    }
            //}

            // osetreni, kdyz tam neni pridan
            //if ((window as any).mobileAndTabletCheck != null) {
            //    profile = (window as any).mobileAndTabletCheck() === true ? mobileProfile : defaultProfile;
            //}

            this.grid.ggrid({
                filtering: true,
                rowsClass: (metarow) => {

                    if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                        // thazmuka (26.10.2021) - async vyřízení, zakomentování, dokud se to nedořeší
                        if (metarow.data.vyriz_async != null && metarow.data.vyriz_async > 0) {
                            return " grid-asyncsettlement-epk-list ";
                        }
                    }
                    
                    // kontrola, že jedná o seznam "K vyřízení"
                    // kontrola, že je parametr zvýraznění zapnut - && that.zvyrazneniNeprectenych
                    if ((this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) && this.zvyrazneniNeprectenych === true && metarow && metarow.data && metarow.data.priz_view_epk === 0){
                        if (metarow.data.aktivita === 100 && this.ixs_fun === metarow.data.ixs_fun_komu)
                            return " grid-noview-epk-list ";
                    }
                    // nepřečtené vlastní žádosti
                    else if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                        if (this.zvyrazneniNeprectenychVlastni === true) {
                            if (this.stavZadosti === Wfl.Interface.GWflczpvEnum.Nevyrizeno)
                                return " ";
                            if (metarow && metarow.data && metarow.data.priz_view_epk_od === 0) {
                                if (metarow.data.aktivita === 100 && this.ixs_fun === metarow.data.ixs_fun_od)
                                    return " grid-noview-epk-list ";
                            }
                        }
                    }
                    else if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani) {    // DLE VYŘIZOVATELE
                        if (this.zvyrazneniNeprectenychVlastni === true) {
                            if (metarow && metarow.data && (metarow.data.priz_view_epk == null || metarow.data.priz_view_epk <= 10)) {
                                if (metarow.data.aktivita === 100 && this.ixs_fun === metarow.data.ixs_fun_komu)    
                                    return " grid-noview-epk-list ";
                            }
                        }
                    }



                    return " ";
                },
                defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
                    name: "gridRowSelectedAct",
                    run: (ev, ctx) => {
                        this.row = ctx.cellInfo.data;	
                        // thazmuka (16.8.2022) - na parametr otevřít detail dokumentu, mělo by být přístupné pouze z modulu USU
                        if (this.EpkParams.usu_epk_dvojkls === 1)
                            this.openDetailDokument();
                        else 
                            this.openDetail(this.row);
                    }
                }),

                defaultProfile: profile,
                profiles: profiles,
                // neaktivní záznamy zešednou
                rowsEnabled: (metarow) => {
                    if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                        //if (metarow.data.vyriz_async != null && metarow.data.vyriz_async > 0)  // thazmuka (08.06.2021) - pro async. vyřízení - pokud je větší než 0, tak by měl být nastaven jako disabled
                        //    return false;
                        if (metarow.data.aktivita === 100 && this.ixs_fun === metarow.data.ixs_fun_komu)
                            return true;
                        else
                            return false;
                    }
                    return true;    // thazmuka (26.01.2021) - v ostatních případech vždy true
                },
                cellActivate: (ev, obj) => {
                    if (this.closed === true)                    // ošetření při zavření contentu
                        return;
                    var activeRow = this.grid.ggrid("activeRow");
                    if (activeRow != null) 
                        this.setPrectene(activeRow);
                },
                selection: (ev, obj) => {
                    // ošetření při zavření contentu
                    if (this.closed === true) {
                        return;
                    }
                    // aktivní řádek
                    //var activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto = this.grid.ggrid("activeRow");
                    var selection = this.grid.ggrid("getSelection");
                    //var multi = selection != null && selection.length > 1;

                    var activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null = null;
                    var multi = false;
                    if (selection != null && selection.length > 0) {
                        activeRow = selection[0];   // první vybraný řádek
                        if (selection.length > 1)
                            multi = true;
                    }

                    //// VOLITELNÝ DŮVOD PODPISU (thazmuka 25.5.2022) - fixnuto 8.6.2022
                    //// - pokud je row prázdné => vyčištění
                    //if (this.row == null || activeRow == null) {
                    //    this.clearSettlementReason();
                    //}
                    //// - pokud je ixp A ZÁROVEŃ ser_cislo stejné => stejná žádost => nic nedělám
                    //// - pokud je ixp jiné NEBO ser_cislo jiné => jiná žádost => provedu vyčištění
                    //if (this.row != null && activeRow != null) {
                    //    if (activeRow.ixp !== this.row.ixp || activeRow.ser_cislo !== this.row.ser_cislo) {
                    //        this.clearSettlementReason();
                    //    }
                    //}

                    // v případě prázdného gridu vyčistit sidebar
                    if (activeRow == null) {
                        this.row = null;
                        new Gordic.Epk.WebControls.MenuButtonsService().setButtonsEmptyGrid(this, this.typPozadavku);
                    }
                    else {
                        this.row = activeRow;
                        //this.setPrectene(this.row!);
                        this.preSetStates(this.row!, multi);

                        // specialite pro Vlastní žádosti
                        this.setZrusitZadostdoEPK();
                    }
                    this.epkActionTS.updateBadgeHandVisualSign(this, this.row, multi);
                    this.updateSidebar();
                },
                multi: multiState,
                data: this.view,
                name: "gridSeznam",
                renderMode: "auto",
                columnMode: "full",
                customClass: "epk-maingrid",
                navigationMode: "row",
                columns: this.format,
                contextMenu: this.createContextMenu(),
                sort: sort,
                searchColumns: searchColumns,
            });

            //#endregion

            //#region --- uživ. filtrování dle barvy ---

            // thazmuka (11.7.2022)
            if (this.uzo != null) {
                var currentProfile = this.grid.ggrid("getCurrentProfile");
                if (currentProfile != null) {
                    // mezi sloupci není sloupec uzo - doplním nebo se to podělá :)
                    if (currentProfile.columnList != null && currentProfile.columnList.search("uzo") === -1)
                        currentProfile.columnList = "uzo," + currentProfile.columnList;
                    currentProfile.columns = { uzo: { filterValue: { variantId: "selection", value: [this.uzo] } } };
                    currentProfile.filterVisible = true;
                    this.grid.ggrid("refreshProfile");
                    this.filter.gfilterpanel("clear");


                 


                }
            }

            //#endregion


            this.callContextMenu();

        }

        private createIslGrid() {

            //#region ** ISL VIEW **

            var that = this;

            this.view = new Gordic.Isl.View(Gordic.Isl.ElectronicSignatureBookRequest.list(rq => {
                var filters = this.getFilter();
                return { filters: filters }
            }), {
                //filterPanel: this.filter,
                key: "ixp, ser_cislo, dat_pozad", // doplněno dat_pozad pro unikatnejsi ID (snad se to nikde nepo...) thazmuka (20.01.2021)
                startEmpty: true,
                processors: {
                    filter: new Gordic.Data.FilterProcessor<Gordic.Wfl.Interface.GPodpisovaKnihaDto>((mrow) => {
                        if (this.typPozadavku != null)
                            return mrow.data.typ_pozad_pod === this.typPozadavku;
                        //else if (this.uzo != null)
                        //    return mrow.data.uzo === this.uzo;
                        else
                            return true;
                    }),
                    default: new Gordic.Data.ComputedFieldsProcessor((mrows) => {
                        mrows.forEach(function (mrow) {

                            ////#region --- settlement_reason (počítaný sloupec) ---

                            //var settlement_reason = "";
                            //var keyPath = String.Format("settlementReason.{0}{1}", mrow.data.ixp!, mrow.data.ser_cislo!.toString());

                            //if (that.globalSettings != null && keyPath !== "") {
                            //    var value: string = that.globalSettings.get(keyPath);
                            //    settlement_reason = value == null ? "" : value.trim();
                            //}
                            //mrow.data.settlement_reason = settlement_reason;

                            ////#endregion

                            // sloupec - Žádost na el. přílohu
                            mrow.data.request_attachment = mrow.data.ixb_elp != null ? 1 : 0;
                            // sloupec - návaznost žádosti

                            if (mrow.data.aktivita != null && mrow.data.sch_pov != null)
                                mrow.data.navaznost = mrow.data.aktivita !== 100 ? 1 : mrow.data.sch_pov === 10 ? 2 : 0;    // 1 - závislý úkon, 2 - povinný úkon, 0 -zbytek

                            // sloupec - související dokumenty
                            mrow.data.exist_souv_dok = mrow.data.poc_souv_dok > 0 ? 1 : 0;

                            //#region -- sloupec - termín vyřízení --

                            if (mrow.data.dat_vyriz_plan == null) {
                                mrow.data.termin_vyrizeni = 0;
                            }
                            else {

                                var dat_vyriz_plan = mrow.data.dat_vyriz_plan;
                                if (typeof mrow.data.dat_vyriz_plan === "string")
                                    dat_vyriz_plan = Gordic.Utils.DateTime.parse(mrow.data.dat_vyriz_plan);

                                var today = new Date() as any;
                                let diff_days = Gordic.Utils.DateTime.diff(today, dat_vyriz_plan, "days");

                                if (diff_days < 0) {
                                    // nevyřízeno po
                                    mrow.data.termin_vyrizeni = 1;
                                }
                                else {
                                    if (diff_days < that.EpkParams.gin_epk_updoter!) {
                                        // nevyřízeno těsně před
                                        mrow.data.termin_vyrizeni = 2;
                                    }
                                    else {
                                        // nevyřízeno před
                                        mrow.data.termin_vyrizeni = 3;
                                    }
                                }
                            }

                            //#endregion

                        })
                    })
                }
            });

            this.view.on("working", (opts) => {
                this.onWorking(opts);
            });

            this.view.on("change", (opts) => {
                this.setBadgeNumbersToSubtasks();
                this.updateMenuBar(opts.rowCount);
            });
           
            //#endregion

            if (this.uzo != null) {
                //todo: filtr nejde vypnout
                this.view.refresh();
            }

        }

        private uzo: UzoEnum;


        /** příprava zrychleného vyřízení */
        private initFastSettlement(state) {

            if (this.globalSettings != null && this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni)
                this.gridCheckAll(state);

            //return;

            if (this.onlyOnceFast !== true)
                return;

            if (this.globalSettings != null && this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                if (this.gridCheckAll(state)) {
                    if (this.actions.actVyrizeni != null)
                        this.actions.actVyrizeni.run();     // spuštění hromadného vyřízení
                    this.onlyOnceFast = false;
                }
            }
        }

        private onWorking(working: boolean) {
            if (this.globalSettings != null) {
                let fastSettlement = this.globalSettings.get("Global.Epk.AppSettings.FastMultiSettlement");
                if (working === false && fastSettlement)
                    this.initFastSettlement(fastSettlement);
                else if (working === false && this.uzo != null)
                    this.checkColorRows(working);
            }
        }

        private checkColorRows(working: boolean) {
            if (this.globalSettings != null && this.uzo != null && working === false) {
                var path = "Global.Epk.AppSettings.CheckAll.";
                if (this.uzo === UzoEnum.Red)
                    this.gridCheckAll(this.globalSettings.get(path + "Red"));
                else if (this.uzo === UzoEnum.Green)
                    this.gridCheckAll(this.globalSettings.get(path + "Green"));
                else if (this.uzo === UzoEnum.Blue)
                    this.gridCheckAll(this.globalSettings.get(path + "Blue"));
                else if (this.uzo === UzoEnum.Purple)
                    this.gridCheckAll(this.globalSettings.get(path + "Purple"));
                else if (this.uzo === UzoEnum.Yellow)
                    this.gridCheckAll(this.globalSettings.get(path + "Yellow"));
                else if (this.uzo === UzoEnum.White)
                    this.gridCheckAll(this.globalSettings.get(path + "White"));
            }
        }

        /**
         * označit všechny řádky
         */
        private gridCheckAll(checkAll: boolean) {
            if (this.grid == null)
                return false;
            var instance: any = this.grid.ggrid("instance");
            if (checkAll === true && instance.actions != null && instance.actions.actCheckAll != null) {
                instance.actions.actCheckAll.run();         // označit všechny řádky
                return true;
            }
            return false;
        }


        /** přednatavení stavů tlačítek */
        private preSetStates(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, multi: boolean) {

            if (row != null) {

                //#region -- donačtení informací  o dalších 2 navázaných šablonách pro Ukrajinu (pouze pro Rozhodnout) --

                if (row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Rozhodnout && row.ixs_ssa != null && row.ixs_sro != null) {

                    this.beginOperation({ id: "readLinkedTemplateId" });

                    Gordic.Isl.ElectronicSignatureBookRequest.readLinkedTemplate({ IxsSsa: row.ixs_ssa, IxsSro: row.ixs_sro }).getData()
                        .then((data) => {
                            this.LinkedTemplate = data;
                            this.common.preSetStates({
                                cnt: this,
                                row: row,
                                sessionIxsFunFlag: this.common.isRequestMineAndActive(row, this.ixs_fun),
                                setChecks: true,
                                multi: multi
                            });
                            this.endOperation("readLinkedTemplateId");
                        })
                }

                //#endregion

                //#region -- pro ostatní požadavky klasicky rovnou nastavím --

                else {
                    this.common.preSetStates({
                        cnt: this,
                        row: row,
                        sessionIxsFunFlag: this.common.isRequestMineAndActive(row, this.ixs_fun),
                        setChecks: true,
                        multi: multi
                    });
                }

                //#endregion

            }

        }

        /** zavolání contextového menu při pravém kliku myši */
        private callContextMenu() {
            this.grid.contextmenu((ev) => {
                var activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto = this.grid.ggrid("activeRow");
                var selection = this.grid.ggrid("getSelection");
                var multi = selection != null && selection.length > 1;
                this.common.setVyriditButtons(this, this.common.isRequestMineAndActive(activeRow, this.ixs_fun), multi);
            });
        }

        /**
         * nastavit řádek jako přečtený
         * @param row data řádku
         */
        private setPrectene(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            if (this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VlastniZadosti &&
                this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.KVyrizeni && 
                this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani)   // todo: tuto podmínku asi časem smáznu, už nebude dávat smysl
                return;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti && this.stavZadosti === Wfl.Interface.GWflczpvEnum.Nevyrizeno)
                return;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                if (this.zvyrazneniNeprectenych !== true)
                    return;
                if (row != null && row.aktivita === 100 && this.ixs_fun === row.ixs_fun_komu) {
                    var keys = Object.keys(row);
                    // ošetření proti možnosti seskupení na gridu
                    if (keys.length > 1) {
                        if (row.priz_view_epk !== 10) {
                            row.priz_view_epk = 10;
                            this._setRowRead(row, row.priz_view_epk);
                        }
                    }
                }
            }
            else if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                if (this.zvyrazneniNeprectenychVlastni !== true)
                    return;
                if (row != null && row.aktivita === 100 && this.ixs_fun === row.ixs_fun_od) {
                    var keys = Object.keys(row);
                    // ošetření proti možnosti seskupení na gridu
                    if (keys.length > 1) {
                        if (row.priz_view_epk_od !== 10) {
                            row.priz_view_epk_od = 10;
                            this._setRowReadOwn(row, true);
                        }
                    }
                }
            }
            else if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani) {
                if (this.zvyrazneniNeprectenych !== true)
                    return;
                if (row != null && row.aktivita === 100 && this.ixs_fun === row.ixs_fun_komu) {
                    var keys = Object.keys(row);
                    // ošetření proti možnosti seskupení na gridu
                    if (keys.length > 1) {
                        if (row.priz_view_epk == null || row.priz_view_epk <= 10) {
                            row.priz_view_epk = 20;         // označení přečteno pro seznam Vráceno k přepracování (wflszps)
                            this._setRowRead(row, row.priz_view_epk);
                        }
                    }
                }
            }
           
        }

        /**
         * nastavení příznaků nepřečteno/přečteno na seznamech K Vyřízení a Vráceno k přepracování (wflszps)
         * @param row řádek podpisové knihy
         * @param priz_view_epk 0 - nepřečteno, 10 - přečteno k vyřízení, 20 - vráceno k přepracování (info. pokud načítám nepřečteno pro vráceno k přepracování, tak beru množinu s hodnotami 0 i 10)
         */
        private _setRowRead(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, priz_view_epk: number) {
            if (this.zvyrazneniNeprectenych !== true)
                return;
            if (row == null)
                return;
            if (row.ixp != null && row.ser_cislo != null)
                Gordic.Isl.ElectronicSignatureBookRequest.setRowRead({ Ixp: row.ixp, SerCislo: row.ser_cislo, PrizViewEpk: priz_view_epk }).getData();
            var metaRow: MetaRow<Gordic.Wfl.Interface.GPodpisovaKnihaDto> = { _isMeta: true/*, _isVirtual: true*/, data: row };
            this.view.updateData(metaRow, "update");
            return metaRow;
        }

        private setNeprecteneVyrizovatel() {
            if (this.zvyrazneniNeprectenych === false)
                return;
            if (this.grid == null)
                return;

            var row: Gordic.Wfl.Interface.GPodpisovaKnihaDto = this.grid.ggrid("activeRow");
            if (row == null)
                return;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni || this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani) {
                if (row.priz_view_epk === 10 || row.priz_view_epk === 20) { // info: v případě vráceno k přepracování se jedná o hodnotu 20 (thazmuka 30.8.2021)
                    row.priz_view_epk = 0;
                    this._setRowRead(row, row.priz_view_epk);
                }
            }
            return;
        }

        private _setRowReadOwn(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto, read: boolean) {
            if (this.zvyrazneniNeprectenychVlastni !== true)
                return;
            if (row == null)
                return;
            if (row.ixp != null && row.ser_cislo != null)
                Gordic.Isl.ElectronicSignatureBookRequest.setRowOwnRequestRead({ Ixp: row.ixp, SerCislo: row.ser_cislo, Read: read }).getData();
            var metaRow: MetaRow<Gordic.Wfl.Interface.GPodpisovaKnihaDto> = { _isMeta: true, data: row };
            this.view.updateData(metaRow, "update");
            return metaRow;
        }

        /** nastavení příznaku nepřečtené žádosti (pouze na seznamu Vlastní žádosti typu: Vráceno k přepracování | Vyřízeno) */
        private setNeprectene() {
            if (this.zvyrazneniNeprectenychVlastni === false) 
                return;
            if (this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                return;
            if (this.stavZadosti === Wfl.Interface.GWflczpvEnum.Nevyrizeno)
                return;
            // výběr řádků
            var rows = this.grid.ggrid("getSelection");
            // meta výběr řádků
            var metaRows: MetaRow<Gordic.Wfl.Interface.GPodpisovaKnihaDto>[] = [];
            for (var index = 0; index < rows.length; index++) {
                // řádek
                var row: Gordic.Wfl.Interface.GPodpisovaKnihaDto = rows[index];
                // přečtený řádek
                if (row.priz_view_epk_od === 10) {
                    row.priz_view_epk_od = 0;
                    if (row.ixp != null && row.ser_cislo != null) {
                        var metaRow = this._setRowReadOwn(row, false);
                        if (metaRow != null)
                            metaRows.push(metaRow);
                    }
                }
            }
            this.view.updateData(metaRows, "update");
        }

        /** přidání termínu vyřízení do filtru */
        private addEpkTermin(obj: any) {

            if (obj["epk_termin"] != null)  // již naplněno
                return;

            // zjišťuji hodnotu epk_terminu, který je vložen v datumovém políčku jako hodnota
            // probíhá to pouze na seznamu k vyřízení
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni || this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                // přidání do filtru termín vyřízení - před, těsně před, po
                var date = this.filter.findFields().gfield("getValue");

                // tento případ je pro existující intervalové políčko
                //if (date != null && date.epk_termin != null)
                //    obj["epk_termin"] = date.epk_termin;
                // toto řešení je pro zobrazení bez datumového filtru
                if (this.epk_termin != null)
                    obj["epk_termin"] = this.epk_termin;

            }
        }

        private getFilterPocetZadosti() {

            var obj = this.presetFilters();

            obj["typ_seznamu"] = this.TypSeznamu;
            obj["ssl_epk_plus"] = this.EpkParams.ssl_epk_plus;

            //if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni)
            //    obj["typ_pozadavku"] = this.typPozadavku;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                obj["stav_zadosti"] = this.stavZadosti;

            // thazmuka (17.8.2021) - před ISL callem smažu name políčka (thisweek, today,...) - nepotřebuji ho, ukládám to mimo a padalo mi to na to
            if (obj["name"] !== undefined)
                delete obj["name"];

            return obj;
        }

        private presetFilters() {

            //info: úprava skládání filtrů dat. intervalů pro ISL (thazmuka 13.9.2023)

            var obj: any = {};
            // filterData by měli být vždy ve výchozím stavu nastaveny
            if (this.filterData != null) {
                obj = JSON.parse(JSON.stringify(this.filterData));

                if (this.filterData[this.datVyrizPlanName] != null) {
                    for (const key in this.filterData[this.datVyrizPlanName]) {
                        const value = this.filterData[this.datVyrizPlanName][key];
                        if (key === "date") {
                            obj[this.datVyrizPlanName] = value;
                        }
                        if (key === "epk_termin") {
                            obj[key] = value;
                        }
                    }
                }

                if (this.filterData[this.datVyrizeniName] != null) {
                    for (const key in this.filterData[this.datVyrizeniName]) {
                        const value = this.filterData[this.datVyrizeniName][key];
                        if (key === "date") {
                            obj[this.datVyrizeniName] = value;
                        }
                        if (key === "epk_termin") {
                            obj[key] = value;
                        }
                    }
                }

                if (this.filterData[this.datPozadName] != null) {
                    for (const key in this.filterData[this.datPozadName]) {
                        const value = this.filterData[this.datPozadName][key];
                        if (key === "date") {
                            obj[this.datPozadName] = value;
                        }
                        if (key === "epk_termin") {
                            obj[key] = value;
                        }
                    }
                }
            }

            return obj;
        }

		/**
		 * získat filtry
		 * @returns
		 */
        private getFilter() {

            var obj = this.presetFilters();

            // fitrování dle type seznamu, ve většině případů poznám díky jejich aktivitě z jaké tabulky jsou záznami načteny
            // kromě seznamu vlastních žádostí, který načítá z obou tabulek a je dospecifikován filtrem vyřízeno
            obj["typ_seznamu"] = this.TypSeznamu;

            // pro filtrování dle subtasků (badgů) - podepsat, schválit, posoudit,...
            // thazmuka (29.3.2022) - zakomentovani - vždy načtu vše a vyfiltruji klientsky
            //obj["typ_pozadavku"] = this.typPozadavku;


            // např. pro filtrování dle celého úřadu
            obj["ssl_epk_plus"] = this.EpkParams.ssl_epk_plus;
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                obj["stav_zadosti"] = this.stavZadosti;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                if (this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat || this.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {
                    obj["sign_type"] = this.signType;
                }
            }
            // thazmuka (17.8.2021) - před ISL callem smažu name políčka (thisweek, today,...) - nepotřebuji ho, ukládám to mimo a padalo mi to na to
            if (obj["name"] !== undefined)
                delete obj["name"];

            return obj;
        }

        private refreshGrid() {
            if(this.filter != null)
                this.filter.gfilterpanel("applyFilter");
        }

		/**
		 * update gridu
		 */
        private updateGrid() {
            this.refreshGrid();
        }

        //#endregion

        //#region *** MENUBAR ***

		/**
		 * vytvořit menubar
		 */
        private createMenuBar() {
            const menuBar: MenuParams[] = [];

            //// ASYNC VYŘÍZENÍ
            //if (this.IsDebug === true || (this.parentContent != null && this.parentContent["K203Params"].LicAdr === "DEMO")) {
            //    if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
            //        menuBar.push(this.addVyriditAsyncButton());
            //        menuBar.push(this.addResetAsyncButton());
            //        //menuBar.push(this.addGenerateRequestButton());
            //    }
            //}

            if (this.EpkParams.epk_asyncvyriz === 1 && this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                console.log("Asynchronní vyřízeno je povoleno a zobrazeno menu tlačítko pro jeho provedení.");
                //menuBar.push(this.addVyriditAsyncButton());
                menuBar.push(this.addResetAsyncButton());
            }

            menuBar.push(this.addDetailButton("actDetail"));
            menuBar.push(this.addDetailDokumentButton("actDetailDokument"));

            if (this.EpkParams.ssl_epk_vyrid! > 0) {        // thazmuka 25.11.2021 - zobrazovat tlačítka pouze pokud lze vyřídit dle DB parametru T16062

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                    menuBar.push(this.addVyriditButton("actVyrizeni"));
                    menuBar.push(this.addVratitButton("actVratit"));
                    menuBar.push(this.addKPosouzeniButton("actKPosouzeni"));
                }

            }

            // thazmuka (27.2.2023) - akce se zobrazí vždy, bude jít kliknout a případně padne na nemožnost zrušení ve SPG
            // kde je to navázáno na parametr gin_epk_ukzru
            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                menuBar.push(this.addZrusitZadostButton("actZrusitZadostdoEPK"));
            }

            if (this.EpkParams.ssl_epk_vyrid! > 0) { 

                if (this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VracenoKPrepracovani &&
                    this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno &&
                    this.TypSeznamu !== Wfl.Interface.TypSeznamuEpk.VPosouzeni
                ) {
                    menuBar.push(this.addButtonZmenaPriority("actChangePriorita"));
                }

                if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni) {
                    if (this.EpkParams.gin_pdf_pictpos !== 0 && this.EpkParams.epk_povumipod !== 0) {
                        menuBar.push(this.addActionUmisteniPodpisu("actUmistitPodpis"));
                    }
                }

            }

            this.menuBar(menuBar);
        }

        private addActionUmisteniPodpisu(name: string) {
            return this.epkActionTS.getParamActionSignatureLocation(this, name);
        }

        private serverZrusitZadosti: GContent;

        private addZrusitZadostButton(name: string) {
            return {
                visiblePriority: 65,
                favorite: true,
                action: this.actions.add(new GAction({
                    enabled: false,
                    name: name,
                    icon: "fa-times-circle g-state-text g-state-error",
                    caption: "jres:32000494", //RC 32000494 : Zrušit žádost
                    tooltip: "jres:32000495", //RC 32000495 : Zrušit žádost do Elektronické podpisové knihy
                    run: () => {

                        if (this.serverZrusitZadosti == null)
                            this.serverZrusitZadosti = new GContent("Gordic.Epk.WebControls.GEpkVlastniZadostiService");

                        var that = this;
                        this.hideFlash("idZrusitZadostFlash");
                        var rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] = this.grid.ggrid("getSelection");

                        if (rows.length > 0) {
                            if (rows.length === 1) {    // pouze jedna žádost
                                this.dialogs.confirm("jres:32000500", "jres:32000501").on("close", (ev, retVal) => { //RC 32000501 : Opravdu chcete zrušit vybranou žádost?
                                    if (retVal && retVal === "yes") {
                                        var row = rows[0];
                                        this.serverZrusitZadosti.call("ZrusitZadostdoEPK", { Ixp: row.ixp, SerCislo: row.ser_cislo })
                                        .then(() => {
                                            this.refreshGrid();
                                            this.showFlash({ id: "idZrusitZadostFlash", content: "jres:32000497", state: "success" }); //RC 32000497 : Žádost byla úspěšně zrušena.
                                        })
                                    }
                                });
                            }
                            else {                      // více žádostí
                                Epk.Dialogs.GEpkZrusitVlastniZadostiDlg(that, { Rows: rows })
                                    .then(() => {
                                        this.refreshGrid();
                                    })
                            }
                        }
                        else {
                            this.showFlash({ id: "idZrusitZadostFlash", content: "jres:32000496", state: "info" }); //RC 32000496 : Není vybrán příslušný řádek.
                        }
                    }
                }))
            } as MenuParams;
        }

        private getParams(zpusobVyrizeni: Gordic.Wfl.Interface.GWflczpvEnum, duvodVyrizeni: boolean) {

            this.hideFlash("idFlashVyriditState");

            var output = this.validateRow();

            if (this.vyriditState == null) {
                this.showFlash({
                    id: "idFlashVyriditState",
                    state: "warning",
                    content: "jres:32000674" //RC 32000674 : Nelze provést vyřízení žádosti, není nastaven stav vyřízení.
                });
                return null;
            }

            if (output == null || output.row == null)
                return null;

            var params: Wfl.Interface.GEpkCompleteConfigDto = {       
                
                Ixp: output.row.ixp!,
                SerCislo: output.row.ser_cislo!,
                IxsDpo: output.row.ixs_dpo!,
                TypPozadavku: this.vyriditState,
                ZpusobVyrizeni: zpusobVyrizeni,
                DuvodVyrizeni: duvodVyrizeni,
                CasRazitko: this.casoveRazitko.checked,
                CasRazitkoPrilohy: this.casoveRazitkoPriloha.checked, // thazmuka (14.4.2020)
                PodepsatObraz: this.podepsat.checked,
                PodepsatPrilohy: this.podepsatPrilohy.checked,
                PredPodepsanimKonvertovat: this.zkonvertovat.checked,
                ZkonvertovatPrilohy: this.zkonvertovatPrilohy.checked,
                PodepsatPrilohyNePdf: this.podepsatPrilohyNePDF.checked,
                GuidGFRM: ""
            }

            return params;
        }


        /** nastavení tlačítka pro zrušení žádostí T23822 */
        private setZrusitZadostdoEPK() {
            var zrusitZadostState = false;

            if (this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                if (this.stavZadosti === Wfl.Interface.GWflczpvEnum.Nevyrizeno)
                    zrusitZadostState = true;
                if (this.row?.refused_flag != null && this.row?.refused_flag > 0)
                    zrusitZadostState = true;
            }

            if (this.actions.actZrusitZadostContext != null)
                this.actions.actZrusitZadostContext.enabled(zrusitZadostState);
            if (this.actions.actZrusitZadostdoEPK != null)
                this.actions.actZrusitZadostdoEPK.enabled(zrusitZadostState);
        }

		/**
		 * aktualizace stavů v menubaru
		 * @param {number} rowCount
		 */
        private updateMenuBar(rowCount: number) {

            var aktivniVlastiZadost = false;
            if (this.row != null) {
                aktivniVlastiZadost = this.row.aktivita === 100 && this.ixs_fun === this.row.ixs_fun_komu;
            }
            var flagKVyrizeni = this.TypSeznamu === Wfl.Interface.TypSeznamuEpk.KVyrizeni && aktivniVlastiZadost;

            // povolení/zakázání tlačítka zrušit žádost (thazmuka 17.3.2021)
            // updated v1   21.3.2022
            // updated v2   05.12.2022  T23822
            if (rowCount !== 0) {
                this.setZrusitZadostdoEPK();
            }

            if (this.actions.actDetail != null) {
                this.actions.actDetail.update({
                    enabled: rowCount !== 0
                })
            }

            if (this.actions.actDetailDokument != null) {
                this.actions.actDetailDokument.update({
                    enabled: rowCount !== 0
                })
            }

            if (this.actions.actUmistitPodpis != null) {
                this.actions.actUmistitPodpis.update({
                    enabled: rowCount !== 0
                })
            }

            if (this.actions.actHromadneVyrizeni != null) {
                this.actions.actHromadneVyrizeni.update({
                    enabled: rowCount === 0 ? false : flagKVyrizeni
                })
            }
            if (this.actions.actVratit != null) {
                this.actions.actVratit.update({
                    enabled: rowCount === 0 ? false : flagKVyrizeni
                });
            }

            //#region -- K VYŘÍZENÍ --

            if (this.actions.actVyrizeni != null) {
                var vyriditEnabled = rowCount === 0 ? false : flagKVyrizeni;
                this.actions.actVyrizeni.update({
                    enabled: vyriditEnabled
                });
                if (this.actions.actNastaveniVyrizeni != null) {
                    this.actions.actNastaveniVyrizeni.update({
                        enabled: vyriditEnabled
                    })
                }
            }

            //#endregion

            //#region -- NASTAVENÍ POVOLENÍ AKCE ZMĚNA PRIORITY --

            if (this.actions.actChangePriorita != null)
                this.actions.actChangePriorita.update({ enabled: rowCount !== 0 });
            if (this.actions.actChangePrioritaContext != null)
                this.actions.actChangePrioritaContext.update({ enabled: rowCount !== 0 });

            //#endregion

        }

        /** přidat tlačítko občerstvení */
        private addRefreshButton() {
            return {
                align: "opposite",
                favorite: true,
                action: this.actions.add(new GAction({
                    enabled: true,
                    name: "actRefreshEpkGrid",
                    icon: "gi-refresh",
                    tooltip: "jres:32000390", //RC 32000390 : Občerstvení seznamu
                    caption: "jres:32000390", //RC 32000390 : Občerstvení seznamu
                    run: () => {
                        this.refreshGrid();
                        // this.view.requestData();
                        // this.load();
                    }
                }))
            } as MenuParams;
        }

		/**
		 * přidat tlačítko k posouzení
		 * @returns
		 */
        private addKPosouzeniButton(myName: string) {
            //RC 26265003 : K posouzení
            return {
                visiblePriority: 70,
                favorite: true, action: this.actions.add(new GAction({
                    customClass: "epk-posoudit-button-class k_posouzeni_menu_class",
                    enabled: false,
                    name: myName,
                    icon: "fa-gavel g-state-text g-state-info", // 10.02.2021 thazmuka - pridani ikony // 7.10.2021 - změna ikony
                    caption: "jres:26265003", //RC 26265003 : K posouzení
                    run: () => {

                        this.hideFlash("idFlashVyrizeni");
                        var selection = this.grid.ggrid("getSelection");

                        if (selection == null || selection.length === 0) {
                            this.showFlash({
                                id: "idFlashVyrizeni",
                                content: "jres:32000515", //RC 32000515 : Nelze provést akci, seznam je pravděpodobně prázdný.
                                state: "warning"
                            });
                            return;
                        }

                        new Epk.WebControls.Vyrizeni.PosouzeniEpk().predatKPosouzeniDaniNaVedomi(this, selection)
                            .then((state: boolean) => {
                                if (state === true)
                                    this.refreshGrid();
                            })
                    }
                }))
            } as MenuParams;
        }

		/**
		 * přidat tlačítko pro vrácení k přepracování
		 * @returns
		 */
        private addVratitButton(myName: string) {
            //caption:  RC 32000040 : Vrátit k přepracování
            return {
                visiblePriority: 90,
                favorite: true, action: this.actions.add(new GAction({
                    customClass: "epk-vratit-button-class",
                    enabled: false,
                    name: myName,
                    icon: "fa-times-circle g-state-text g-state-error", caption: "jres:32000040",
                    run: () => {

                        this.hideFlash("idFlashVyrizeni");
                        var output = this.validateRow();

                        if (output.state == null) {
                            this.showFlash({
                                id: "idFlashVyrizeni",
                                content: "jres:32000515", //RC 32000515 : Nelze provést akci, seznam je pravděpodobně prázdný.
                                state: "warning"
                            });
                        }

                        if (output.state === EpkValidateRowEnum.one) {
                            var dto = this.getParams(Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani, true);
                            if (dto != null) {
                                const done = () => {
                                    console.info("EPK: Jednotlivé vrácení bylo dokončeno.");
                                    this.refreshGrid();
                                }
                                const rqList: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                                rqList.push(dto);
                                new Settlement({ cnt: this, done: done, row: output.row! }).run(rqList);
                            }
                        }
                        else if (output.state === EpkValidateRowEnum.multi) {
                            this.hromadneVyrizeni(Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani);
                        }
                        else {

                            this.showFlash({
                                id: "idFlashVyrizeni",
                                content: "jres:32000515", //RC 32000515 : Nelze provést akci, seznam je pravděpodobně prázdný.
                                state: "warning"
                            });
                        }


                    }
                }))
            } as MenuParams;
        }

        /**
         * přidat timeout před vyřízením - pokud není ještě dokreslen nový stav gridu
         */
        private addTimeoutBeforeSettlement() {
            var isLoading = this.view.isLoading();
            if (isLoading === false)                // grid je donačten
                return;
            setTimeout(() => {
                this.addTimeoutBeforeSettlement();
            }, 500);
        }

        private addResetAsyncButton() {

            //todo: final - tlačítko by mělo být enabled, pouze pokud je žádost zablokována
            var that = this;

            return {
                visiblePriority: 100,
                favorite: false,
                action: this.actions.add(new GAction({
                    enabled: true,
                    name: "actResetAsync",
                    icon: "gi-epk",
                    caption: "jres:32000929", //RC 32000929 : Odblokování žádostí
                    tooltip: "jres:32000930", //RC 32000930 : Odblokování žádostí asynchronního vyřízení
                    run: () => {

                        this.hideFlash("idFlashResetAsync");
                        var selection: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] | null = this.grid.ggrid("getSelection");
                        if (selection == null)
                            return;
                        var now = new Date();

                        var result: any = selection.map((item) => {

                            var vyriz_async = item.vyriz_async;
                            var dat_pozad_async = item.dat_pozad_async;

                            if (vyriz_async == null || vyriz_async === 0 || dat_pozad_async == null) {
                                this.showFlash({
                                    content: "jres:32001053", //RC 32001053 : Žádost není zablokovaná
                                    state: "info",
                                    id: "idFlashResetAsync" 
                                });
                                return null;
                            }

                            var dateObj = that.getAsyncLimitDate(dat_pozad_async!);
                            // pokud přesáhne žádost limit, lze odblokovat a to se následně provede
                            if (dateObj.date < now) {
                                return item;
                            }
                            else {
                                this.showFlash({ content: String.Format("jres:32001052 {0}", dateObj.string), state: "warning", id: "idFlashResetAsync" }); //RC 32001052 : Žádost lze odblokovat v
                                return null;
                            }

                        }).filter((value) => {
                            if (value != null)
                                return value;
                        });

                        if (result != null && result.length > 0) {
                            this.beginOperation({ id: "idResetAsyncOp", text: "jres:32000765" }); //RC 32000765 : Probíhá odblokování asynchronních žádostí
                            this.resetAsync(result, 0);
                        }

                    }
                }))
            } as MenuParams
        }

        private getAsyncLimitDate(dat_pozad_async: JsonDate) {

            var dat_pozad = Gordic.Utils.DateTime.parse(dat_pozad_async);
            var minutes = this.EpkParams.epk_asynclimit!;

            var date = Gordic.Utils.DateTime.addMinutes(dat_pozad, minutes);
            var dateHourString = Gordic.Templates.Formatters.date(date, "hh:mm");

            return { date: date, string: dateHourString };
        }

        /**
         * prevedení resetování async metody
         * @param selection výběr
         * @param index index řádku
         */
        private resetAsync(selection: Gordic.Wfl.Interface.GPodpisovaKnihaDto[], index: number) {

            var row = selection[index];

            if (row == null) {
                this.endOperation("idResetAsyncOp");
                return;
            }

            Gordic.Isl.ElectronicSignatureBookRequest.setAsyncRequest({ Ixp: row.ixp!, SerCislo: row.ser_cislo!, State: Gordic.Wfl.Interface.GEpkWflcvyaEnum.NotRunning }).getData()
                .then(() => {
                    if ((selection.length - 1) === index) {
                        this.endOperation("idResetAsyncOp");
                        this.refreshGrid();

                        this.showFlash({
                            content: "jres:32001054", //RC 32001054 : Žádost byla úspěšně odblokována
                            state: "success",
                            id: "idFlashResetAsync"
                        });

                        return;
                    }
                    this.resetAsync(selection, ++index);
                })
                .fail(() => {

                    this.showFlash({
                        content: "jres:32001055", //RC 32001055 : Při odblokování žádosti došlo k chybě
                        state: "error",
                        id: "idFlashResetAsync"
                    });

                    this.endOperation("idResetAsyncOp");
                })
        }


		/**
		 * přidat tlačítko pro vyřízení
		 * @returns
		 */
        private addVyriditButton(myName: string) {

            return {
                visiblePriority: 100,
                customClass: "epk-vyridit-button-class",
                children: [{
                    favorite: false,
                    action: this.actions.add(new GAction({
                        name: "actNastaveniVyrizeni",
                        caption: "jres:32000256",		//RC 32000256 : Upřesnit vyřízení
                        run: () => {
                            var activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto = this.grid.ggrid("activeRow");

                            if (activeRow == null)
                                return;

                            this.common.showUpresneniVyrizeni(this, this.common.isRequestMineAndActive(activeRow, this.ixs_fun))
                                .then(() => {

                                    if (activeRow == null)
                                        return;

                                    //#region --- settlement_reason ---

                                    var keyPath = String.Format("settlementReason.{0}{1}", activeRow.ixp!, activeRow.ser_cislo!.toString());

                                    if (this.globalSettings != null && keyPath !== "") {
                                        var value: string = this.globalSettings.get(keyPath);
                                        activeRow["settlement_reason"] = value == null ? "" : value.trim();
                                        this.view.updateData(activeRow, "update");
                                    }

                                    //#endregion

                                })
                        }
                    }))
                }],
                favorite: true,
                action: this.actions.add(new GAction({
                    enabled: false,
                    name: myName,
                    icon: "fa-check-circle g-state-text g-state-success",
                    caption: "jres:32000064",				//RC 32000064 : Nelze vyřídit
                    run: () => {

                        this.addTimeoutBeforeSettlement();

                        this.hideFlash("idBanMultiSatisfy");    // pokud je definován a je vytvořen, tak je před dalším vyřízením smazán
                        this.hideFlash("idFlashVyrizeni");

                        var output = this.validateRow();

                        if (output.state == null) {
                            this.showFlash({
                                id: "idFlashVyrizeni",
                                content: "jres:32000515", //RC 32000515 : Nelze provést akci, seznam je pravděpodobně prázdný.
                                state: "warning"
                            });
                        }

                        if (output.state === EpkValidateRowEnum.one) {

                            $.Deferred().resolve().promise()
                                .then(() => {
                                        if (this.gfrmPanel != null)
                                            return this.gfrmPanel.run(this.EpkParams.epk_gfrmzobr!, output.row?.akce_epk!);
                                        return null;
                                })
                                .then((saveDto) => {

                                    var guidGFRM: string = "";
                                    if (saveDto != null && saveDto.fileInfo != null && saveDto.fileInfo.guid != null) {
                                        guidGFRM = saveDto.fileInfo.guid;
                                    }
                                        
                                    var dto = this.getParams(Gordic.Wfl.Interface.GWflczpvEnum.Povoleno, false);

                                    if (dto != null) {
                                        dto.GuidGFRM = guidGFRM;
                                        const done = () => {
                                            console.info("EPK: Jednotlivé vyřízení bylo dokončeno.");
                                            this.refreshGrid();
                                        }
                                        const rqList: Wfl.Interface.GEpkCompleteConfigDto[] = [];
                                        rqList.push(dto);
                                        new Settlement({ cnt: this, done: done, row: output.row! }).run(rqList);
                                    }

                                })

                        }
                        else if (output.state === EpkValidateRowEnum.multi) {
                            this.hromadneVyrizeni(Wfl.Interface.GWflczpvEnum.Povoleno);
                        }
                        else {

                            this.showFlash({
                                id: "idFlashVyrizeni",
                                content: "jres:32000515", //RC 32000515 : Nelze provést akci, seznam je pravděpodobně prázdný.
                                state: "warning"
                            });
                        }
                    }
                }))
            } as MenuParams
        }

        /** hromadné vyřízení
         * - přes tlačítko "podepsat", chci odebrat tlačítko hromadné vyřízení 
         * - musím ještě provést validaci, jestli vůbec mohu hromadně vyřizovat
         */
        private hromadneVyrizeni(zpus_vyriz: Wfl.Interface.GWflczpvEnum) {


            if (this.EpkParams.epk_povhrovyriz === false) {

                this.showFlash({
                    id: "idFlashHromadneVyrizeni",
                    content: "jres:32000379", //RC 32000379 : Hromadné vyřízení není povoleno.
                    state: "error"
                });
                return;
            }

            var result = this.validateHromadneVyrizeni();

            if (result.state === validHromVyrizEnum.Uspech) {
                Gordic.Epk.Dialogs.GEpkMultiSettlementDlg(this, { ixps: result.ixps, zpus_vyriz: zpus_vyriz }, Global.Enums.ModOtevreni.navigate)
                    .then(() => {
                        this.refreshGrid();
                        //this.view.requestData();
                    })
            }

        }

        //#region validace hromadného vyřízení

		/**
		 * validace hromadného vyřízení
		 */
        private validateHromadneVyrizeni(): { state: validHromVyrizEnum, ixps: { ixp: string, ser_cislo: number }[] } {

            // vyberu řádky
            var data: any[] = this.grid.ggrid("getSelection");
            /** pole identifikátorů */
            var ixps: { ixp: string, ser_cislo: number }[] = [];
            // prázdný seznam
            if (data.length === 0) {
                return { state: validHromVyrizEnum.NeuspechPrazdnyGrid, ixps: ixps };
            }
            // validace řádků před vyřízením (aktivita === 100), možné dodat další validace
            var newData: any[] = [];
            for (var index = 0; index < data.length; index++) {
                var value = data[index];
                if (value.aktivita === 100) {
                    newData.push(value);
                }
            }
            // obsahuje nevalidní záznamy, rovná se 0, protože může být vybrán max. jeden
            if (newData.length === 0) {
                return { state: validHromVyrizEnum.NeuspechNevalidniZaznamy, ixps: ixps };
            }
            else {
                // dostanu výběr řádku, které mohu posunout k hromadnému vyřízení
                for (var index = 0; index < newData.length; index++) {
                    var ixp: string = data[index].ixp;
                    var ser_cislo: number = data[index].ser_cislo;
                    ixps.push({ ixp: ixp, ser_cislo: ser_cislo });
                }
                return { state: validHromVyrizEnum.Uspech, ixps: ixps };
            }
        }

        //#endregion

		/**
		 * přidat tlačítko detail do menubaru
		 * @returns
		 */
        private addDetailButton(name: string) {
            var param: MenuParams = {
                favorite: true,
                visiblePriority: 70,
                action: this.actions.add(new GAction({
                    enabled: true,
                    name: name,
                    icon: "gi-detail",
                    caption: "jres:32000105",            //RC 32000105 : Detail žádosti
                    run: () => {

                        if (this.closed === true)
                            return;

                        var selection = this.grid.ggrid("getSelection");
                        this.hideFlash("idFlashEpkDetail");

                        if (selection.length > 1) {
                            // multi výběr
                            this.showFlash({
                                id: "idFlashEpkDetail",
                                content: "jres:32000362", //RC 32000362 : Nelze přejít na detail při výběru více řádků.
                                state: "warning"
                            });
                        }
                        else if (selection.length === 1) {

                            var row = selection[0] as Gordic.Wfl.Interface.GPodpisovaKnihaDto;

                            this.openDetail(row);

                        }
                        else {

                            this.showFlash({
                                id: "idFlashEpkDetail",
                                content: "jres:32000363", //RC 32000363 : Seznam je prázdný.
                                state: "warning"
                            });
                        }

                    }
                }))
            };
            return param;
        }

        private addDetailDokumentButton(name: string) {

            return {
                align: "opposite",
                //primary: true,
                //favorite: true,
                action: this.actions.add(new GAction({
                    name: name,
                    icon: "gi-detail",
                    caption: "jres:32000657", //RC 32000657 : Detail dokumentu/spisu
                    run: () => {
                        this.openDetailDokument();
                    }
                }))
            } as MenuParams;

        }

        private openDetailDokument() {

            var flash = "idFlashUsuDetail";
            this.hideFlash(flash);
            var selection: Gordic.Wfl.Interface.GPodpisovaKnihaDto[] = this.grid.ggrid("getSelection");

            if (selection.length > 1) {
                // multi výběr
                this.showFlash("jres:32000847", "warning", flash); //RC 32000847 : Nelze přejít na detail dokumentu/spisu při výběru více řádků.
                return;
            }

            if (selection.length === 1) {
                var row = selection[0] as Gordic.Wfl.Interface.GPodpisovaKnihaDto;
                if (row != null && row.ixp != null) {
                    var options = { DetailDto: { ixp: row.ixp }, grid: this.grid };
                    Gordic.Wfl.Dialogs.DetailDokumentuSpisu(this, options, Global.Enums.ModOtevreni.navigate);
                    return;
                }
            }

            this.showFlash("jres:32000844", "warning", flash); //RC 32000844 : Otevření detailu dokumentu/spisu není k dispozici.

        }

		/**
		 * načíst detail žádosti
		 */
        private openDetail(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null) {
            if (row !== null) {
                var options = { Ixp: row.ixp!, SerCislo: row.ser_cislo!, Grid: this.grid};
                Gordic.Epk.Dialogs.DetailZadostiDlg(this, options, Global.Enums.ModOtevreni.navigate)
                    .then((output) => {

                        if (output == null)
                            return;

                        if (output.flash != null) {
                            this.showFlash(output.flash);
                        }

                        if (output.refresh === true) {
                            this.refreshGrid();
                        }

                    })
            }
        }

		/**
		 * validace řádku pro zjištění, jestli je řádek prázdný, či je vybrán jeden řádek nebo, jestli je řádků vybráno více (multi)
		 */
        private validateRow() {
            var output: { state: EpkValidateRowEnum, row?: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null } = { state: EpkValidateRowEnum.empty, row: null };
            // seznam je nedefinovaný
            if (this.grid == null) {
                return output;
            }
            else {
                // pokud je definovaný, udělá se výběr(selection) řádků na seznamu
                var selection = this.grid.ggrid("getSelection");
                // v seznamu jsou nějaké řádky - žádosti
                if (selection.length > 0) {
                    // výběr jednoho řádku - single
                    if (selection.length === 1) {
                        output.state = EpkValidateRowEnum.one;
                        output.row = selection[0] as Gordic.Wfl.Interface.GPodpisovaKnihaDto;
                        return output;
                    }
                    // výběr více řádků - multi
                    else {
                        output.state = EpkValidateRowEnum.multi;
                        return output;
                    }
                }
                else {
                    // seznam je definovaný, ale prázdný
                    return output;
                }
            }
        }

        //#endregion

        //#region *** SIDEBAR ***

        private gfrmPanel: Gordic.Epk.WebControls.Sidebar.GEpkGfrmPanel;

		/**
		 * Funkce createSidebar vytvoří pravý sidebar vedle seznamu v EPK
		 */
        private createSidebar() {

            this.sidebarFlag = true;

            var left: GSideBarBarOptions | undefined = undefined;
            if (this.EpkParams.epk_gfrmzobr === 1) {
                var leftPanels: GSideBarPanelOptions[] = [];
                this.gfrmPanel = new Gordic.Epk.WebControls.Sidebar.GEpkGfrmPanel();
                leftPanels.push(this.gfrmPanel.create(this));
                left = {
                    pinned: false, panels: leftPanels
                };
            }

            var opt: IGEpkSidebar = {
                cnt: this,
                row: this.row!,
                grid: this.grid
            }

            this.rSide = new GEpkSidebar(opt);

            this.sidebar = this.element.gsidebar({
                left: left,
                right: { pinned: false, panels: this.rSide.createRightPanels() }
            });
        }

        private rSide: GEpkSidebar;

        private updateSidebar() {

            if (this.sidebarFlag === false)
                return;
            if (this.closed)            // zavření contentu - ochrana kvůli pádu
                return;

            var activeRow = this.grid.ggrid("activeRow");

            if (this.tempSidebarRow != activeRow)
                this.tempSidebarRow = activeRow;
            else
                return; // opakovane volani

            this.rSide.updateSidebar(this.sidebar);

            if (activeRow == null)
                return;

            if (this.EpkParams.epk_gfrmzobr === 1) {
                var elPanelGfrm = this.sidebar.gsidebar("getPanel", "panelGfrmForm");
                this.gfrmPanel.loadPanel(this, elPanelGfrm, activeRow.ixp);
            }
    
        }

        //#endregion

    }

}